module.exports = __webpack_public_path__ + "img/Logo_WeAreJako_version2.e575a14d.svg";